/** Time period to get re-get all download center files to look for file related changes. e.g status change. */
export const DOWNLOAD_CENTER_FILES_REFRESH_RATE_MS = 6000;

/** For a particular file down, initial delay to look for file status change (to catch quick file generation). */
export const DOWNLOAD_CENTER_SERVICE_FILE_STATUS_DETECTION_DELAY_MS = 1500;
/** For a particular file down, time period for look ups for file status change (to catch slow file generation). */
export const DOWNLOAD_CENTER_SERVICE_FILE_STATUS_DETECTION_REFRESH_RATE_MS = 5000;
